import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    private baseUrl: string = '';

    loadConfig(): void {
        if (environment.baseUrl) {
            this.baseUrl = environment.baseUrl;
        } else {
            const host = environment.hostname || window.location.hostname,
                port = environment.port || window.location.port,
                { protocol } = window.location;

            this.baseUrl = `${protocol}//${host}:${port}${environment.context}/`;
        }
    }

    getBaseUrl(): string {
        return this.baseUrl;
    }
}